import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router'

import * as R from 'ramda'

import MenuItem from 'material-ui/MenuItem';

import Combobox from 'components/Combobox'

import dataActions from 'actions/dataActions'

import { doc, dirtyRead } from '../selectors/common'
import { owners } from '../selectors/entities'

import { sortSev } from 'utils/stuff'

let select = dirtyRead(
	(state, props) => ({
		owner: doc(state, doc(state, props.objectID).ownerID)
	  , owners: owners(state)
	})
)

export class OwnerCombobox extends Component{
	render(){
		let { props } = this
		let owner = props.owner || {}
		return(
			<Combobox
				icon={
					owner ? <img src={'/' + process.env.REACT_APP_NAME + "/static/img/owner_green.png"}
						style={{
							height: "19px"
						  , position: "relative"
						  , top: "0px"
						  , display: ""}}
					/>
					:<i
						className="material-icons"
						style={{
							float: "left"
							, width: "26px"
							, position: "relative"
							, top: "-5px"
							, left: "-3px"
							, color: "orange"
						}}
					>
						arrow_forward
					</i>
				}
				link={`/manager/owner/${owner._id}/`}
				text={owner.firstName || ""}
				hintText={<span>Enter owner name</span>}
				dataSource={
					R.map(owner => ({
						text: owner.firstName
					  , value: (
							<MenuItem
								key={owner._id}
								primaryText={owner.firstName}
							/>
						)
					  , id: owner._id
				  }), sortSev(props.owners, "firstName"))
				}
				onChange={(owner)=>{
						// if(props.owner._id && props.owner._id != owner.id){
						// 	props.STAGE({
						// 		_id: props.objectID
						// 	  , ownerID: owner.id
						// 	//   , properties:
						// 	//   (
						// 	// 	  props.owners[props.owner._id].properties
						// 	// 	  && props.owners[props.owner._id].properties.length
						// 	//   )?
						// 	//   R.reject(property => property == props.objectID, props.owners[props.owner._id].properties)
						// 	//   : []
						// 		})
						// }
						props.STAGE({
							_id: props.objectID
						  , ownerID: owner && owner.id
						})
						// if(props.owners[owner.id].properties&&!props.owners[owner.id].properties.length){
						// 	props.STAGE({
						// 			_id: owner.id
						// 		, properties: [props.objectID]
						// 	})
						// }
						// if(props.owners[owner.id].properties&&props.owners[owner.id].properties.length&&!R.contains(props.objectID, props.owners[owner.id].properties)){
						// 	props.STAGE({
						// 			_id: owner.id
						// 		, properties:
						// 		(
						// 			props.owners[owner.id].properties
						// 			&& props.owners[owner.id].properties.length
						// 		)?
						// 		[...props.owners[owner.id].properties, props.objectID]
						// 		: [props.objectID]
						// 	})
						// }
					}
				}
				// DELETE={()=>{
				// 	props.STAGE({
				// 		_id: props.object._id
				// 	  , ownerID: ""
				// 	})
				// }}
			/>
		)
	}
}

export default connect(select, R.mergeAll([dataActions]))(OwnerCombobox)



// WEBPACK FOOTER //
// ./src/components/OwnerCombobox.js